<script setup lang="ts">
import { Toaster } from '@eci-saas/ui'
import { useThemeStore } from './stores/theme'

const { isDark, color } = storeToRefs(useThemeStore())
</script>

<template>
  <div :class="{ 'dark': isDark, 'theme-gold': color === 'gold', 'theme-indigo': color === 'indigo' }">
    <Toaster :theme="isDark ? 'dark' : 'light'" rich-colors />
    <RouterView />
  </div>
</template>
